/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-10 20:11:19 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-09-26 01:54:31
 */

import { Injectable } from "@angular/core";
import { ENV } from '../env/env';
import { HttpClient } from "@angular/common/http";
import axios from 'axios';
import { Camera, CameraOptions } from "@ionic-native/camera";
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject, FileUploadOptions } from '@ionic-native/file-transfer';
import { LoadingService } from "./loading.service";
import { Observable } from "rxjs/Observable";
import { TransService } from "./trans.service";

@Injectable()
export class ImageService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/storage`;
  private MAX_FILESIZE = 50 * 1024 * 1024; // 50M

  constructor(
    private transService: TransService,
    private camera: Camera,
    private http: HttpClient,
    private transfer: FileTransfer,
    private file: File,
    private loadingService: LoadingService,
  ) {
  }

  uploadImage(type: string, file: any) {

    if (file.size > this.MAX_FILESIZE) {
      return Observable.throw({ error: { code: -100, message: '10M bytes 까지 가능합니다.' } });
    }

    let iId;
    return this.http.get(`${this.url}/signed?type=${type}&lang=${this.transService.lang}`)
      .switchMap(res => {
        const { url, imageId } = res['payload'];
        iId = imageId;
        return axios.put(url, file, {
          headers: {
            'Content-Type': file.type,
          }
        });
      })
      .map(() => iId)
  }


  deleteImage(id) {
    if (!id)
      return Observable.of({});
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }


  uploadImageByUrl(type: string, fileUrl: any) {
    let iId;
    return this.http.get(`${this.url}/signed?type=${type}&lang=${this.transService.lang}`)
      .switchMap(res => {
        const { url, imageId } = res['payload'];
        iId = imageId;

        const fileTransfer: FileTransferObject = this.transfer.create();
        let options: FileUploadOptions = {
          httpMethod: 'PUT',
          chunkedMode: false,
          headers: {
            'Content-Type': 'image/jpeg'
          }
        };
        return fileTransfer.upload(fileUrl, url, options);
      })
      .map(() => iId)
  }


  uploadImageFromCamera(type: string, sourceType: number) {

    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.FILE_URI,
      sourceType: sourceType,
      allowEdit: false,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum: false,
      correctOrientation: true,
    };

    // Get Image file url
    return new Promise((resolve, reject) => {
      this.camera.getPicture(options)
        .then(fileUrl => resolve(fileUrl))
        .catch((errMessage: string) => reject({ error: { message: errMessage } }));
    })
      // file url to file 
      .then((fileUrl: string) => {
        this.loadingService.showLoading(true);
        return this.file.resolveLocalFilesystemUrl(fileUrl)
          .then(oneFile => Promise.resolve({ fileUrl, oneFile }))
      })
      // file to file meta
      .then(({ fileUrl, oneFile }) => {
        return new Promise((resolve, reject) => {
          oneFile.getMetadata((metadata) => {
            if (metadata.size > this.MAX_FILESIZE) {
              return reject({ error: { code: -100, message: '파일 사이즈가 너무 큽니다' } });
            }
            resolve(fileUrl);
          }, () => {
            reject({ error: { code: -100, message: '파일 메타정보를 가져오는 중에 에러가 발생했습니다.' } });
          });
        });
      })
      // file url to upload
      .then(fileUrl => {
        return new Promise((resolve, reject) => {
          this.uploadImageByUrl(type, fileUrl)
            .subscribe(imageId => {
              resolve(imageId);
            }, error => reject(error));
        });
      });
  }

  getResizedUrl(imageId: string, size: string) {
    if (!imageId || !size)
      return '';
    const params = imageId.split('_');
    if (params.length < 1)
      return '';

    const type = params[0];
    return `${ENV.S3_URL}/resized/${type}/${imageId}_${size}.jpg`;
  }


  getOriginalUrl(imageId: string) {
    if (!imageId)
      return '';
    const params = imageId.split('_');
    if (params.length < 1)
      return '';
    const type = params[0];
    return `${ENV.S3_URL}/original/${type}/${imageId}.jpg`;
  }
}



// WEBPACK FOOTER //
// ./src/services/image.service.ts